import {Box, Button, Grid, makeStyles, TextField} from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import _ from 'lodash';
import TopBar from "../../components/Common/TopBar";
import OrderForwardToolManagement from "../../components/OrderForwardTool";
import FullscreenLoading from "../../components/Common/FullscreenLoading";

const useStyles = makeStyles((theme)=> ({
    root: {
        backgroundColor: theme.palette.background.default,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        margin: 0
    },
    appBarClasses: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        padding: theme.spacing(1)
    }
}))

function OrderForwardTool() {
    const dispatch = useDispatch();
    const classes = useStyles();
    const {t} = useTranslation('orderForwardTool');

    const radios = {
        orders: {
            text: t('orders')
        },
        batches: {
            text: t('forwarded_batches')
        },
        scan: {
            text: t('scan')
        }
    }

    const loading = useSelector(state => state.orderExchangeReducer.queryTaskListLoading || state.orderExchangeReducer.queryToBeForwardOrdersLoading)

    const [radio, setRadio] = useState('orders');

    const handleRadioChange = (event) => {
        setRadio(event.target.value);
    }

    return (
        <Box className={classes.root}>
            <TopBar 
                title={t('order_forward_tool')}
                appBarClasses={classes.appBarClasses}
                radios={radios}
                radio={radio}
                handleRadioChange={handleRadioChange}
            />
            <OrderForwardToolManagement type={radio} />
            <FullscreenLoading open={loading} />
        </Box>
    );
}

export default OrderForwardTool;